export default __webpack_public_path__ + "static/service-icon6-e67104c93c1bc49200cd770ee239070c.png";